export default __webpack_public_path__ + "static/media/filter_alt-24px.18e92018.svg";